import { createFileRoute, useParams } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';
import { CourseQuizzesView } from '@/views/quizzes/course-quizzes-view.tsx';

// 课程 quiz 列表（角色感知：学生尝试次数 / 教师状态计数）。
export const Route = createFileRoute('/_learner/courses_/$id/quizzes/')({
  component: QuizzesTab,
});

function QuizzesTab() {
  const { id } = useParams({ from: '/_learner/courses_/$id/quizzes/' });
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return <CourseQuizzesView courseId={id} user={user} />;
}
